// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promote_student {
  position: relative;
}
.promote_student a {
  text-decoration: none;
  color: #202020;
}
.promote_student a .card .icon {
  height: 60px;
  width: 60px;
  line-height: 60px;
  border-radius: 50%;
  font-size: 1.5rem;
  text-align: center;
  background: #dedede;
}
.promote_student .Custom_Exam_Syllabus .card-group .card .branch-list li:hover,
.promote_student .Custom_Exam_Syllabus .card-group .card .branch-list li.active,
.promote_student .Custom_Exam_Syllabus .card-group .card .section-list li:hover,
.promote_student .Custom_Exam_Syllabus .card-group .card .section-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
}
.promote_student .Custom_Exam_Syllabus .card-group .card .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}
.promote_student .Custom_Exam_Syllabus .card-group .card .group-list li {
  font-size: 13px;
  padding: 0.2rem 0;
  margin: 0;
  text-transform: capitalize;
}
@media (max-width: 1199.98px) {
  .promote_student .Custom_Exam_Syllabus .card-group .card + .card {
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 1199.98px) {
  .promote_student .Custom_Exam_Syllabus .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .promote_student .Custom_Exam_Syllabus .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/settings/promote_students/_promotestudent.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,qBAAA;EACA,cAAA;AACR;AACQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AACZ;AAOgB;;;;EAII,eAAA;EACA,kBAAA;EACA,mBAAA;AALpB;AAQgB;EACI,sBAAA;EACA,yBAAA;AANpB;AASgB;EACI,eAAA;EACA,iBAAA;EACA,SAAA;EACA,0BAAA;AAPpB;AAYQ;EACI;IACI,iDAAA;EAVd;AACF;AAaQ;EACI;IACI,aAAA;IACA,sBAAA;EAXd;EAac;IACI,uBAAA;IACA,mBAAA;EAXlB;AACF","sourcesContent":[".promote_student {\n    position: relative;\n\n    a {\n        text-decoration: none;\n        color: #202020;\n\n        .card .icon {\n            height: 60px;\n            width: 60px;\n            line-height: 60px;\n            border-radius: 50%;\n            font-size: 1.5rem;\n            text-align: center;\n            background: #dedede;\n        }\n    }\n\n    .Custom_Exam_Syllabus {\n        .card-group {\n            .card {\n\n                .branch-list li:hover,\n                .branch-list li.active,\n                .section-list li:hover,\n                .section-list li.active {\n                    cursor: pointer;\n                    border-radius: 2px;\n                    background: #EFEFEF;\n                }\n\n                .list-unstyled li {\n                    padding: 0.2rem 0.5rem;\n                    text-transform: uppercase;\n                }\n\n                .group-list li {\n                    font-size: 13px;\n                    padding: 0.2rem 0;\n                    margin: 0;\n                    text-transform: capitalize;\n                }\n            }\n        }\n\n        @media (max-width: 1199.98px) {\n            .card-group .card+.card {\n                border: 1px solid rgba(0, 0, 0, 0.125) !important;\n            }\n        }\n\n        @media (max-width: 1199.98px) {\n            .card-group {\n                display: flex;\n                flex-flow: column wrap;\n\n                .card {\n                    flex-direction: inherit;\n                    margin-bottom: 15px;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
